<template>
  <div class="storege-status">
    <div class="head">
      <span>My Storage</span>
      <span>Upgrade</span>
    </div>
    <div class="content">
      <!-- {{getUserInfo.percentage===undefined}} -->
      <vue-circle
      v-if="getUserInfo.hasOwnProperty('percentage')"
        ref="myprogress"
        :progress="getUserInfo.percentage"
        :size="100"
        :reverse="false"
        line-cap="round"
        :fill="fill"
        empty-fill="rgba(0, 0, 0, .1)"
        :animation-start-value="0"
        :start-angle="300"
        insert-mode="append"
        :animation="{ duration: 1200, easing: 'circleProgressEasing' }"
        :thickness="10"
        :show-percent="true"
        @vue-circle-progress="progress"
        @vue-circle-end="progress_end"
        >
      </vue-circle>
      <!-- <span class="bar_value" style="display:none;">{{getUserInfo.percentage}}</span>
      <div class="ldBar label-center" data-preset="circle" style="width:110px;height:110px"></div> -->
      <div class="details">
        <h4>Files Record</h4>
        <span>{{getUserInfo.total_file}} Files</span>
        <h4 class="size">Size</h4>
        <span>{{getUserInfo.total_file_size}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import VueCircle from './index.vue'
// import "../js/loading-bar.js";
import { mapGetters } from "vuex";
export default {
   components: {
      VueCircle
    },
  data() {
    return {
      user_image: {},
      fill :" #015EC8",
        // p: this.getUserInfo.percentage
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"])
  },
  name: "Storagestatus",
  // mounted() {  
    // console.log(this.getUserInfo.percentage)
  //   // progress bar uploading file
  //   let ProgressPercnt = document.querySelector(".prcnt");
  //   // let lineProgress = document.querySelector('.line-bar');
  //   let growLine = document.querySelector(".grow");
  //   window.addEventListener("load", () => {
  //     let value = ProgressPercnt.innerHTML;
  //     growLine.style.width = `${value}%`;
  //   });
  //   let atr = document.querySelector(".ldBar");
  //   let val = document.querySelector(".bar_value").innerText;
  //   atr.setAttribute(`data-value`, `${val}`);
  // },
   methods:{
      progress(event,progress,stepValue){
        // console.log(stepValue);
        this.p = this.getUserInfo.percentage
        if (stepValue > 30) {
          this.$refs.myprogress.updateFill('#e3f218');
        }
      },
      progress_end(event){
        // console.log("Circle progress end");
      },
      redraw(){
        this.$refs.myprogress.updateProgress(60);
      }
    },
    
  }
</script>

<style scoped>
  @import 'https://fonts.googleapis.com/css?family=Ruda';
</style>